export { default } from './ModalIllustrativeIconRegister'
